import { useTranslations } from 'next-intl';
import { useAtomValue } from 'jotai';

import { 
	keywordAtom,
	filteredResultAtom,
	isSelectedOnlyAtom,
} from '@/atoms/league-filter';
import { useFilterSabaString } from '@/hooks/query/use-saba-filter';
import { useLeagueFilter } from '@/features/league-filter/hooks/use-league-filter';

import { CheckBoxSquareIcon, CheckBoxActiveSquareIcon } from '@/components/icons/svg-icons';
import { EmptyContentMessage } from '@/components/layout/empty-content-message';
import { Highlighter } from '@/components/text/highlighter';

export const LeagueFilterResult = () => {
	const t = useTranslations('General');
	const { filterSabaString } = useFilterSabaString();
	const keyword = useAtomValue(keywordAtom);
	const filteredResult = useAtomValue(filteredResultAtom);
	const isSelectedOnly = useAtomValue(isSelectedOnlyAtom);
	const { 
		tempSelectAllChecked, 
		tempSelectedLeagues, 
		setTempSelectedLeagues 
	} = useLeagueFilter();

	let filteredLeagueSet = filteredResult.map(leagueItem => {
		return {
			...leagueItem,
			checked: tempSelectAllChecked || Boolean(
				tempSelectedLeagues.find(item => item.leagueId === leagueItem.leagueId)?.checked
			)
		};
	});

	if (isSelectedOnly) {
		filteredLeagueSet = filteredLeagueSet.filter(leagueItem => leagueItem.checked);
	}

	const addLeague = (leagueId: number) => () => { 
		const newLeagueList = tempSelectedLeagues.map(leagueItem => ({
			...leagueItem,
			checked: leagueItem.leagueId === leagueId 
				? !leagueItem.checked 
				: leagueItem.checked
		}));
		setTempSelectedLeagues(newLeagueList);
	};

	const stopPropagation = (event: React.MouseEvent) => {
		event.stopPropagation();
	};

	const leagueList = filteredLeagueSet.map(leagueItem => {
		return (
			<label 
				key={leagueItem.leagueId}
				className="checkbox select-league__item"
				data-selected={leagueItem.checked}
				onClick={addLeague(leagueItem.leagueId)}
			>
				<input 
					type="checkbox" 
					onClick={stopPropagation}
				/>

				{leagueItem.checked ? <CheckBoxActiveSquareIcon /> : <CheckBoxSquareIcon />}
				
				<span className="checkbox__text">
					<Highlighter 
						text={filterSabaString(leagueItem.leagueName)}
						highlightWords={[keyword]}
						className="select-league__highlight"
					/>
				</span>
			</label>
		);
	});

	return (
		<div className="select-league__list">
			{leagueList.length > 0 
				? leagueList 
				: (
					<EmptyContentMessage 
						type="search"
						title={t('lbl_NoResult')}
					/>
				)}
		</div>
	);
};